<template>
  <div></div>
</template>
<script>
import axios from "axios"
import { baseApiUrl } from "@/global"
import pdfmake from "pdfmake"

export default {
  data() {
    return {
      imageB64: ''
    }
  },
  methods: {
    async generate(qrCodes) {
      const response = await axios.post(`${baseApiUrl}/qrcode/generate`, { qrCodes })
      this.imageB64 = response.data
      this.makePDF()
    },
    makePDF() {
      const docDefinition = {
        info: {
          title: `QR Code`,
        },
        content: [{
          image: this.imageB64,
          width: 595.28
        }],
        pageMargins: [15, 15, 0, 0]
      }
      pdfmake.createPdf(docDefinition).open()
    }
  },
}

</script>
